"use client";

import * as React from "react";
import * as LabelPrimitive from "@radix-ui/react-label";

import { cn } from "./utils";

function Label({
  className,
  ...props
}: React.ComponentProps<typeof LabelPrimitive.Root>) {
  return (
    <LabelPrimitive.Root
      data-slot="label"
      className={cn(
        // Tebox-aligned with BrandSettingsCard title: body scale, semibold, brand font via Tailwind `font-sans` → var(--brand-font)
        "flex items-center gap-2 select-none text-[14px] font-medium leading-[1.3] text-[var(--brand-text)] font-sans group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50 peer-disabled:cursor-not-allowed peer-disabled:opacity-50",
        className,
      )}
      {...props}
    />
  );
}

export { Label };
